import React, { useState, useEffect } from 'react';
import NavLinks from '../Navbar/NavLinks';
import { HashLink } from 'react-router-hash-link';
import carLogo from '../../images/carlistic_logo.png';


const NavBar = () => {
    const [top, setTop] = useState(!window.scrollY);
    const [isOpen, setisOpen] = React.useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const scrollTimeoutRef = React.useRef(null);

    function handleClick() {
        setisOpen(!isOpen);
    }

    useEffect(() => {
      const scrollHandler = () => {
        const currentScrollY = window.pageYOffset;
        
        // Show navbar at the top
        if (currentScrollY < 50) {
          setTop(true);
          setIsVisible(true);
          return;
        }
        
        setTop(false);
        
        // Hide on scroll down, show on scroll up
        if (currentScrollY > lastScrollY) {
          setIsVisible(false); // Scrolling down
        } else {
          setIsVisible(true); // Scrolling up
        }
        
        setLastScrollY(currentScrollY);
        
        // Clear existing timeout
        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
        }
        
        // Show navbar after scroll stops
        scrollTimeoutRef.current = setTimeout(() => {
          setIsVisible(true);
        }, 1000);
      };
      
      const touchHandler = () => {
        setIsVisible(true);
        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
        }
      };
      
      window.addEventListener('scroll', scrollHandler);
      window.addEventListener('touchstart', touchHandler);
      
      return () => {
        window.removeEventListener('scroll', scrollHandler);
        window.removeEventListener('touchstart', touchHandler);
        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
        }
      };
    }, [lastScrollY]);

    return (
<nav className={`fixed top-0 w-full z-30 transition duration-300 ease-in-out mb-16 ${!top && 'bg-[rgba(10,10,14,0.78)] shadow-lg backdrop-blur'} ${!isVisible ? '-translate-y-full' : 'translate-y-0'}`}>
            <div className="flex flex-row justify-between items-center py-2">
                <div className="flex flex-row justify-center md:px-12 md:mx-12 items-center text-center font-bold">
                                        <HashLink smooth to="/#hero">
                                            <h1 className="font-extrabold text-4xl text-amber-500 flex items-center space-x-4">
                                                <div className="overflow-hidden h-16 md:h-20 lg:h-28 flex items-center">
                                                    <img src={carLogo} alt="Carlistic" className="h-full w-auto object-contain block border-0 bg-transparent"/>
                                                </div>
                                                {/* <span>
                                                    Carlistic<sup className="text-base align-super text-amber-500">TM</sup>
                                                </span> */}
                                            </h1>
                                        </HashLink>
                </div>
                <div className="group flex flex-col items-center">
                    <button className="p-2 rounded-lg lg:hidden text-blue-900" onClick={handleClick}>
                        <svg className="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            {isOpen && (
                            <path fillRule="evenodd" clipRule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
                            )}
                            {!isOpen && (
                            <path fillRule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
                            )}
                        </svg>
                    </button>
                    <div className='hidden space-x-6 lg:inline-block p-5'>
                        <NavLinks />
                    </div>

<div className={`fixed transition-transform duration-300 ease-in-out transit flex justify-center left-0 w-full h-auto rounded-md p-24 bg-[rgba(10,10,14,0.90)] lg:hidden shadow-xl top-14 backdrop-blur ${  isOpen ? "block" : "hidden" } `}>
                        <div className='flex flex-col space-y-6'>
                            <NavLinks />
                        </div>                                                
                    </div>

                </div>
            </div>
        </nav>
    )
    
}


export default NavBar;
